(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/pay-footer.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/pay-footer.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
setGlobal('svs.tickets.play.components.PlayFooter', _ref => {
  let appTimeline = _ref.appTimeline,
    gamePayed = _ref.gamePayed,
    ticketInfo = _ref.ticketInfo,
    handleGameDemo = _ref.handleGameDemo,
    handleGamePay = _ref.handleGamePay,
    handleGift = _ref.handleGift;
  const price = ticketInfo.price;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    playerBalance = _useState2[0],
    setPlayerBalance = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    remindReady = _useState4[0],
    setRemindReady = _useState4[1];
  const isTriss = svs.tickets.data.templateConfig.branding === 'triss';
  useEffect(() => {
    svs.components.account_balance.get(true, balance => {
      if (playerBalance !== balance) {
        setPlayerBalance(balance);
      }
    });
  }, [playerBalance, setPlayerBalance]);
  useEffect(() => {
    if (gamePayed) {
      gsap.to(document.querySelector('.payfooter'), 1, {
        y: '120%',
        ease: 'power4.out'
      });
    } else {
      gsap.to(document.querySelector('.payfooter'), 1, {
        y: '0',
        ease: 'power4.out'
      });
    }
  }, [gamePayed]);
  useEffect(() => {
    const reminder = gsap.timeline({
      onComplete: () => {
        setRemindReady(true);
      }
    });
    appTimeline.add(reminder, 'gameReady+=0.5');
    return () => {
      reminder.kill();
    };
  }, [appTimeline]);
  return React.createElement(Payfooter, {
    balance: playerBalance,
    buttons: [{
      pay: true,
      onClick: handleGamePay,
      className: 'qa-btn-pay',
      disabled: gamePayed
    }, {
      secondary: true,
      text: 'Ge bort',
      onClick: handleGift,
      visible: ticketInfo.isGiftable,
      disabled: gamePayed
    }, {
      secondary: true,
      text: 'Provspela',
      onClick: handleGameDemo,
      className: 'qa-btn-demo',
      disabled: gamePayed
    }, {
      link: true,
      text: 'Spelpaus24',
      className: 'js-pause24-trigger'
    }],
    hasReminder: remindReady && !gamePayed,
    reminderTrackingLabel: "".concat(isTriss ? 'Triss' : 'Skrapspel'),
    sum: price
  });
});

 })(window);